/**
 * @fileoverview Login page route configuration
 * Handles user authentication and login functionality
 */

// Library imports
import { createFileRoute } from "@tanstack/react-router";

// Page components
import LoginPage from "@/features/auth/pages/login";
import { AuthProvider } from "@/providers/auth.provider";
import { AppErrorBoundary } from "@/components/shared/app-error-boundary";

/**
 * Type definition for login page URL search parameters
 */
interface LoginSearchParams {
  redirect?: string;
  registeredEmail?: string;
  status?: "registration_success";
}

/**
 * Route configuration for the login page
 * Includes search parameter validation and component rendering
 */
export const Route = createFileRoute("/(auth)/login")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Login page" className="min-h-screen w-full">
        <LoginPage />
      </main>
    </AuthProvider>
  ),
  // Validate and type URL search parameters
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => {
    return {
      redirect: search.redirect as string | undefined,
      registeredEmail: search.registeredEmail as string | undefined,
      status: search.status as "registration_success" | undefined,
    };
  },
  errorComponent: AppErrorBoundary,
});
